/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,jsx-a11y/role-supports-aria-props */
import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { shallowEqual, useSelector } from "react-redux";
import * as actions from "../../../_redux/businesses/businessesActions";
import * as crud from "../../../_redux/businesses/businessesCrud";

import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../../_metronic/_partials/controls";
import { EditBusinessForm } from "./EditBusinessForm";
import { CreateBusinessForm } from "./CreateBusinessForm";
import { BusinessHourForm } from "./BusinessHourForm";
import { BusinessImagesForm } from "./BusinessImagesForm";
import { BusinessCoverImagesForm } from "./BusinessCoverImagesForm";
import { useSubheader } from "../../../../../../_metronic/layout";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";
 
const initBusiness = {
  id: undefined,
  name: "",
  business_email: "",
  phone: "",
  area_code: "",
  latitude: "",
  longitude: "",
  show_exact_address: true,
  tagline: "",
  address: "",
  userid: "",
  website: "",
  linkedin: "",
  facebook: "",
  instagram: "",
  tiktok: "",
  x: "",
};

export function BusinessEdit() {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();

  const { user } = useSelector(state => state.auth);
  const userobject = user.userData;
  var admin_role = false;
  if (userobject.admin_role && userobject.admin_role === 'superadmin') { admin_role = true; }
  // Subheader
  const subheader = useSubheader();

  // Tabs
  const initialTab = location.state?.activeTab || "basic";
  const [tab, setTab] = useState(initialTab);
  const [pendingTab, setPendingTab] = useState(null);
  const formikRef = useRef();
  const dispatch = useDispatch();
  // const layoutDispatch = useContext(LayoutContext.Dispatch);
  const { actionsLoading, businessForEdit } = useSelector(
    (state) => ({
      actionsLoading: state.businesses.actionsLoading,
      businessForEdit: state.businesses.businessForEdit,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.fetchBusiness(id));
  }, [id, dispatch]);

  const [title, setTitle] = useState("");
  useEffect(() => {
    let _title = id ? "" : "New Business";
    if (businessForEdit && id) { _title = `${businessForEdit.name} Edit Profile`; }
    setTitle(_title);
  }, [businessForEdit, id]);

  useEffect(() => {
  subheader.setTitle(title);
  }, [title, subheader]);
  const businessImagePage = () => {
    dispatch(actions.fetchBusiness(id));
    document.getElementById("business_images").click();
  }
 
  
  const businessBasicPage = () => {
    dispatch(actions.fetchBusiness(id));
    document.getElementById("basic").click();
  }

  const businessCoverImagePage = () => {
    dispatch(actions.fetchBusiness(id));
    document.getElementById("business_cover_images").click();
  }

  const handleTabClick = (nextTab) => {
    if (nextTab === "basic") {
      setTab(nextTab);
      return;
    }

    if (id) {
      setTab(nextTab);
      return;
    }

    // Creating new business tab change flow
    const formik = formikRef.current;
    if (!formik) {
      alert("Please add basic info first");
      return;
    }

    const { name, userid, business_email } = formik.values;
    if (!name || !userid || !business_email) {
      alert("Please add basic info first");
      return;
    }

    setPendingTab(nextTab);
    if (window.confirm("You want to save the basic information?")) {
      formik.submitForm();
    }
  };

  const exitAfterSaveRef = useRef(false);
  const [saveSuccessMessage, setSaveSuccessMessage] = useState("");

  const saveBusiness = async (values) => {
    const shouldExit = exitAfterSaveRef.current;
    if (!id) {
      dispatch(actions.createBusiness(values)).then((business) => {
        if (business && business.id) {
          if (shouldExit) {
            backToBusinessesList();
          } else {
            setSaveSuccessMessage("Business created successfully!");
            setTimeout(() => setSaveSuccessMessage(""), 5000);
            navigate(`/business/${business.id}/edit`, { state: { activeTab: pendingTab || "basic" } });
          }
        } else {
          backToBusinessesList();
        }
      });
    } 
    else 
    {
      if(admin_role)
      {
        //super admin
         dispatch(actions.updateBusiness(values)).then(() => {
           if (shouldExit) {
             backToBusinessesList();
           } else {
             setSaveSuccessMessage("Business updated successfully!");
             setTimeout(() => setSaveSuccessMessage(""), 5000);
             dispatch(actions.fetchBusiness(id));
           }
         });
      }
      else
      {
        let report_field_array = {}
        if(values.business_images_rep || values.business_logo_image_rep || values.name_checkbox || values.phone_checkbox || values.tagline_checkbox || values.address_checkbox || values.facebook_checkbox || values.area_code_checkbox || values.product_detail_checkbox )
        {
         
          //report some issue to admin only when checked atleast one issue
          report_field_array.logo           = values.business_logo_image_rep
          report_field_array.name           = values.name_checkbox
          report_field_array.phone          = values.phone_checkbox
          report_field_array.tagline        = values.tagline_checkbox
          report_field_array.address        = values.address_checkbox
          report_field_array.facebook       = values.facebook_checkbox
          report_field_array.area_code      = values.area_code_checkbox
          report_field_array.product_detail = values.product_detail_checkbox
          report_field_array.business_images_rep = values.business_images_rep
          await crud.reportBusiness(values.id , userobject.userid , true , report_field_array)
          // dispatch(actions.reportBusiness(values)).then(() => backToBusinessesList());
        } 
        else
        {
          // When everything is ok
          await crud.reportBusiness(values.id , userobject.userid , false , report_field_array)
        }
        if (shouldExit) {
          backToBusinessesList();
        } else {
          setSaveSuccessMessage("Report submitted successfully!");
          setTimeout(() => setSaveSuccessMessage(""), 5000);
        }
      }
    }
  };

  const btnRef = useRef();
  const saveBusinessClick = (exit = false) => {
    exitAfterSaveRef.current = exit;
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  const backToBusinessesList = () => {
    navigate("/business");
  };
  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title}>
        <CardHeaderToolbar>
          <button
            type="button"
            onClick={backToBusinessesList}
            className="btn btn-light"
          >
            <i className="fa fa-arrow-left"></i>
            Back
          </button>
          {`  `}
          <button
            id="button-save"
            type="button"
            className="btn btn-outline-primary ml-2 font-weight-bold"
            onClick={() => saveBusinessClick(false)}
            title="Save changes and continue editing"
          >
            <i className="fa fa-save mr-1"></i>
            {(admin_role) ? 'Save' : 'Report'}
          </button>
          {`  `}
          <button
            id="button-save-exit"
            type="button"
            className="btn btn-primary ml-2 font-weight-bolder"
            onClick={() => saveBusinessClick(true)}
            title="Save changes and exit to list"
          >
            <i className="fa fa-check mr-1"></i>
            {(admin_role) ? 'Save & Exit' : 'Report & Exit'}
          </button>
        </CardHeaderToolbar>
      </CardHeader>
      {saveSuccessMessage && (
        <div className="alert alert-custom alert-light-success fade show m-4 p-3" role="alert">
          <div className="alert-icon">
            <i className="flaticon2-check-mark text-success"></i>
          </div>
          <div className="alert-text font-weight-bold">
            {saveSuccessMessage}
          </div>
          <div className="alert-close">
            <button type="button" className="close" onClick={() => setSaveSuccessMessage("")}>
              <span>&times;</span>
            </button>
          </div>
        </div>
      )}
      <CardBody>
        <ul className="nav nav-tabs nav-tabs-line nav-tabs-pill" role="tablist">
          <li id="basic" className="nav-item" onClick={() => handleTabClick("basic")}>
            <a
              className={`nav-link ${tab === "basic" && "active"}`}
              data-toggle="tab"
              role="tab"
              aria-selected={(tab === "basic").toString()}
            >
              Basic info
            </a>
          </li>
           {admin_role && (
            <>
              {" "}
              <li id="business_images" className="nav-item" onClick={() => handleTabClick("business_images")}>
                <a
                  className={`nav-link ${tab === "business_images" && "active"}`}
                  data-toggle="tab"
                  role="button"
                  aria-selected={(tab === "business_images").toString()}
                >
                  Business Images
                </a>
              </li>

            </>
          )}
          {admin_role && (
            <>
              {" "}
              <li id="business_cover_images" className="nav-item" onClick={() => handleTabClick("business_cover_images")}>
                <a
                  className={`nav-link ${tab === "business_cover_images" && "active"}`}
                  data-toggle="tab"
                  role="button"
                  aria-selected={(tab === "business_cover_images").toString()}
                >
                  Business Cover Images
                </a>
              </li>

            </>
          )}
         
          {admin_role && (
            <>
              {" "}
              <li id="business_hour" className="nav-item" onClick={() => handleTabClick("business_hour")}>
                <a
                  className={`nav-link ${tab === "business_hour" && "active"}`}
                  data-toggle="tab"
                  role="button"
                  aria-selected={(tab === "business_hour").toString()}
                >
                  Business Hour
                </a>
              </li>

            </>
          )}

        </ul>
        <div className="mt-5">

          {tab === "basic" && (
            <EditBusinessForm
              formikRef={formikRef}
              actionsLoading={actionsLoading}
              business={businessForEdit || initBusiness}
              btnRef={btnRef}
              saveBusiness={saveBusiness}
              businessBasicPage={businessBasicPage}
            />
          )}

          {tab === "business_hour" && (
            id ? (
              <BusinessHourForm
                actionsLoading={actionsLoading}
                business={businessForEdit || initBusiness}
                btnRef={btnRef}
                saveBusiness={saveBusiness}
              />
            ) : (
              <div className="text-center p-5">
                <h4>Please save the basic business info first to configure business hours.</h4>
              </div>
            )
          )}
          {tab === "business_images" && (
            id ? (
              <BusinessImagesForm
                actionsLoading={actionsLoading}
                business={businessForEdit || initBusiness}
                btnRef={btnRef}
                saveBusiness={saveBusiness}
                businessImagePage={businessImagePage}
              />
            ) : (
              <div className="text-center p-5">
                <h4>Please save the basic business info first to upload business images.</h4>
              </div>
            )
          )}

          {tab === "business_cover_images" && (
            id ? (
              <BusinessCoverImagesForm
                actionsLoading={actionsLoading}
                business={businessForEdit || initBusiness}
                btnRef={btnRef}
                saveBusiness={saveBusiness}
                businessCoverImagePage={businessCoverImagePage}
              />
            ) : (
              <div className="text-center p-5">
                <h4>Please save the basic business info first to upload cover images.</h4>
              </div>
            )
          )}

        </div>
      </CardBody>
    </Card>
  );
}